import PropTypes from 'prop-types';
import React, { memo, PureComponent } from 'react';

import { FlexView } from '@cuemath/comps';
import { Grid } from 'semantic-ui-react';

import {
  CONTACT_DETAILS_LABELS,
  FIELD_TYPE,
  STUDENT_DEMOGRAPHICS_DETAILS_LABELS,
} from 'constants/student-profile';
import { FieldContainer, LinkContainer } from '../utils/comps';
import { Heading, InfoWrapper, Wrapper } from '../utils/styled-components';

class StudentProfile extends PureComponent {
  static propTypes = {
    student: PropTypes.shape({}).isRequired,
    studentProfileInfo: PropTypes.shape({}).isRequired,
  };

  renderStudentProfileAccordion = (
    heading = '',
    fields = [],
    type = '',
    renderer = () => {},
  ) => {
    return (
      <FlexView>
        <Heading>{heading}</Heading>
        <InfoWrapper>
          <Grid>{renderer(fields, type)}</Grid>
        </InfoWrapper>
      </FlexView>
    );
  };

  renderColumnContainersInGrid = (fields = [], type) => {
    return fields.map((row = [], index) => (
      <Grid.Row key={index}>
        {row.map(({ label, value, width }) => {
          return (
            <React.Fragment key={label}>
              {type === FIELD_TYPE.FIELD && <>{FieldContainer(label, value, width)}</>}
              {type === FIELD_TYPE.LINK && <>{LinkContainer(label, value, width)}</>}
            </React.Fragment>
          );
        })}
      </Grid.Row>
    ));
  };

  renderStudentDemograpicDetails = studentProfileInfo => {
    const {
      first_name: firstName,
      grade,
      id,
      last_name: lastName,
      parent_name: parentName,
      username,
      state = '',
      country_code: countryCode,
      phone,
      email,
    } = studentProfileInfo;

    const {
      FIRST_NAME,
      LAST_NAME,
      USERNAME,
      GRADE,
      PARENT_NAME,
      ID,
      STATE,
    } = STUDENT_DEMOGRAPHICS_DETAILS_LABELS;
    const { HEADING, COUNTRY_CODE, PHONE, EMAIL } = CONTACT_DETAILS_LABELS || {};

    const fieldsData = [
      [
        {
          label: FIRST_NAME,
          value: firstName,
          width: 8,
        },
        {
          label: LAST_NAME,
          value: lastName,
          width: 8,
        },
      ],
      [
        {
          label: USERNAME,
          value: username,
          width: 8,
        },
        { label: ID, value: id, width: 8 },
      ],
      [
        {
          label: PARENT_NAME,
          value: parentName,
          width: 8,
        },
        { label: EMAIL, value: email, width: 8 },
      ],
      [
        { label: STATE, value: state, width: 8 },
        { label: GRADE, value: grade, width: 8 },
      ],
      [
        {
          label: COUNTRY_CODE,
          value: countryCode,
          width: 8,
        },
        { label: PHONE, value: phone, width: 8 },
      ],
    ];

    return this.renderStudentProfileAccordion(
      HEADING,
      fieldsData,
      FIELD_TYPE.FIELD,
      this.renderColumnContainersInGrid,
    );
  };

  render() {
    const { studentProfileInfo = {} } = this.props;

    return (
      <Wrapper>
        <div>{this.renderStudentDemograpicDetails(studentProfileInfo)}</div>
      </Wrapper>
    );
  }
}
export default memo(StudentProfile);
